export default __webpack_public_path__ + "icon_talleres.70de8d.png";